import i18next from "i18next";
import { initReactI18next } from "react-i18next";

// "Inline" English and Arabic translations.
// We can localize to any language and any number of languages.
const resources = {

    de: {
        translation: {
            Bodennavigator: "Bodennavigator",
            choose_type_subfloor: "Wählen Sie die Art des Untergrundes aus? (1/6)",
            choose_subfloor: "Einen Untergrund wählen (2/6)",
            choose_type_flooring: "Welcher Belag soll verwendet werden? (3/6)",
            choose_flooring: "Einen Belag wählen (4/6)",
            specialfeatures: "Besonderheiten (5/6)",
            filler_thikness: "Fläche und Spachtelmasse Schichtdicke (6/6)",
            calculate: "Berechnen",
            special_combination: "Ihre ausgewählte Kombination aus Untergrund und Belag scheint ein Spezialfall zu sein. Unsere Techniker helfen Ihnen gerne! Bitte wenden Sie sich dazu an unsere Technik-Hotline: <a href='tel:00497314097257'>+49(0)731 4097 257</a>",
            resultbase: "Ihre Empfehlung basiert auf folgender Auswahl",
            pdf_download: "PDF herunterladen",
            Standard: "Standard",
            Schnellbau: "Schnellbau",
            StarkeBelastung: "Starke Belastung",
            InfoSubmitText: "Bei einem Aufbau ab 10 mm Schichtdicke bitte eine anwendungstechnische Beratung einholen: UZIN Technikteam <a href='tel:00497314097257'>+49 731 4097-257</a> oder <a href='info@uzin.com'>info@uzin.com</a>"
        },
    },
    en: {
        translation: {
            Bodennavigator: "Floornavigator",
            choose_type_subfloor: "Select the type of subfloor? (1/6)",
            choose_subfloor: "Select a subfloor (2/6)",
            choose_type_flooring: "Which flooring should be used? (3/6)",
            choose_flooring: "Select a floor covering (4/6)",
            specialfeatures: "Special features (5/6)",
            filler_thikness: "Surface and filler Layer thickness (6/6)",
            calculate: "Calculate",
            special_combination: "Your selected combination of subfloor and floor covering appears to be a special case. Our technicians will be happy to help you! Please contact our technical hotline: <a href='tel:00497314097257'>+49(0)731 4097 257</a>",
            resultbase: "Your recommendation is based on the following selection",
            pdf_download: "Download PDF",
            Standard: "Standard",
            Schnellbau: "Rapid construction",
            StarkeBelastung: "Heavy duty",
            InfoSubmitText: "For a layer thickness of 10 mm or more, please obtain technical application advice: UZIN technical team <a href='tel:00497314097257'>+49 731 4097-257</a> or <a href='info@uzin.com'>info@uzin.com</a>"
        },
    },
	cs: {
        translation: {
            Bodennavigator: "Floor Navigator",
            choose_type_subfloor: " Vyberte druh podkladu? (1/6)",
            choose_subfloor: "Druh podkladu (2/6)",
            choose_type_flooring: "Jaký druh podlahové krytiny bude použit?? (3/6)",
            choose_flooring: "Druh podlahové krytiny (4/6)",
            specialfeatures: "Mimořádné vlastnosti (5/6)",
            filler_thikness: "Plocha/ tloušťka vrstvy (6/6)",
            calculate: " Výsledek",
            special_combination: " Vámi zvolená kombinace podkladu a podlahové krytiny je nestandardní. Vyžádejte si radu našeho odborného technického poradce. Volejte Hotline: <a href='tel: 00420602171129'>+420 602 171 129 </a>",
            resultbase: "Vaše doporučení vychází z následujícího výběru ",
            pdf_download: "Stáhnout PDF",
            Standard: "Standard ",
            Schnellbau: "Rychlá výstavba",
            StarkeBelastung: "Vysoké zatížení",
            InfoSubmitText: "For a layer thickness of 10 mm or more, please obtain technical application advice: UZIN technical team <a href='tel:00497314097257'>+49 731 4097-257</a> or <a href='info@uzin.com'>info@uzin.com</a>"
        },
	},
	de_CH: {
        translation: {
            Bodennavigator: "Der Bodennavigator",
            choose_type_subfloor: "Wählen Sie die Art des Untergrundes aus. (1/6)",
            choose_subfloor: "Art des Untergrunds (2/6)",
            choose_type_flooring: "Welcher Belag soll verwendet werden? (3/6)",
            choose_flooring: "Art des Belags (4/6)",
            specialfeatures: "Besonderheiten (5/6)",
            filler_thikness: " Fläche/Schichtdicke (6/6)",
            calculate: " Ergebnis anzeigen",
            special_combination: "Ihre ausgewählte Kombination aus Untergrund und Belag scheint ein Spezialfall zu sein. Unsere Techniker helfen Ihnen gerne! Bitte wenden Sie sich dazu an unsere Technik-Hotline: <a href='tel: 0041416244888'>+41 41 624 48 88</a>",
            resultbase: "Ihre Empfehlung basiert auf der folgenden Auswahl ",
            pdf_download: "PDF herunterladen",
            Standard: "Standard",
            Schnellbau: " Schnellbau ",
            StarkeBelastung: " Starke Belastung ",
            InfoSubmitText: "Bei einem Aufbau ab 10 mm Schichtdicke bitte eine anwendungstechnische Beratung einholen: UZIN Technikteam <a href='tel:0041416244888'>+41 41 624 48 88</a> oder <a href='ch@uzin-utz.com'>ch@uzin-utz.com</a>"
        },
    },
	fr_CH: {
        translation: {
            Bodennavigator: "Le navigateur du sol",
            choose_type_subfloor: "Sélectionner le type de support. (1/6)",
            choose_subfloor: "Type de support (2/6)",
            choose_type_flooring: "Quel revêtement utiliser? (3/6)",
            choose_flooring: "Type de revêtement (4/6)",
            specialfeatures: "Spécificités (5/6)",
            filler_thikness: "Surface épaisseur (6/6)",
            calculate: "Afficher le résultat",
            special_combination: "Vos choix de support et de revêtement semblent être un cas particulier. Notre Service Technique pourra vous aider. Vous pouvez joindre le: <a href='tel:0041416244888'>+41 41 624 48 88</a>",
            resultbase: "Votre recommandation est basée sur la sélection suivante",
            pdf_download: "Télécharger le PDF ",
            Standard: "Standard ",
            Schnellbau: "Construction rapide ",
            StarkeBelastung: "Forte sollicitation ",
            InfoSubmitText: "Pour une épaisseur de couche supérieure ou égale à 10 mm, veuillez demander conseil à notre équipe technique : Équipe technique UZIN <a href='tel:0041416244888'>+41 41 624 48 88</a> ou <a href='mailto:ch@uzin-utz.com'>ch@uzin-utz.com</a>"
        },
    },
	sv: {
        translation: {
            Bodennavigator: "Åtgångskalkylator",
            choose_type_subfloor: "Välj undergolv (1/6)",
            choose_subfloor: "Typ av undergolv (2/6)",
            choose_type_flooring: "Vilken golvbeläggning ska användas? (3/6)",
            choose_flooring: "Typ av golvbeläggning (4/6)",
            specialfeatures: "Ytterligare information (5/6)",
            filler_thikness: "Area/tjocklek (6/6)",
            calculate: "Visa resultat",
            special_combination: "Kontakta oss:Henrik Pettersson (Försljningschef Sverige)Mail: henrik.pettersson@uzin-utz.com Telefon: <a href='tel:00460707992924> +46 0707 992924</a>",
            resultbase: "Din rekommendation baseras på följande urval",
            pdf_download: "Ladda ner PDF",
            Standard: "Standard ",
            Schnellbau: "Snabb installation",
            StarkeBelastung: "Hög belastning",
            InfoSubmitText: "Ved en lagtykkelse på 10 mm eller mere bedes du indhente teknisk rådgivning: UZIN's tekniske  hotline <a href='tel:00497314097257'>25848004</a>."
        },
    },
	da: {
        translation: {
            Bodennavigator: " Gulvguide",
            choose_type_subfloor: " Vælg et undergulv (1/6)",
            choose_subfloor: " Undergulvs type (2/6)",
            choose_type_flooring: " Hvilken gulvbelægning skal bruges (3/6)",
            choose_flooring: " Gulvbelægnings type (4/6)",
            specialfeatures: " Yderligere information (5/6)",
            filler_thikness: " Areal/lagtykkelse (6/6)",
            calculate: "Vis resultater",
            special_combination: "Dine valg af undergulv og gulvbelægning ser ud til at være et specielt tilfælde. Vores tekniske service hjælper dig gerne. Ring til 25844003 / 25848004 for vores hotline til teknisk service.<a href='tel:004525844003 / 004525848004'>+4525844003 / +4525848004</a>",
            resultbase: " Din anbefaling er baseret på følgende valg ",
            pdf_download: "Download PDF",
            Standard: "Standard",
            Schnellbau: " Hurtig installation ",
            StarkeBelastung: " Høj belastning ",
            InfoSubmitText: "Ved lagtykkelser på 10 mm eller derover, venligst kontakt vores danske tekniske hotline på: <a href='tel:00497314097257'>25848004</a> eller <a href='dk@uzin-utz.com'>dk@uzin-utz.com</a>"
        },
    },
	fr: {
        translation: {
            Bodennavigator: " Le Configurateur UZIN",
            choose_type_subfloor: " Choisir le support (1/6)",
            choose_subfloor: " Type de support (2/6)",
            choose_type_flooring: " Quel type de revêtement souhaitez-vous poser? (3/6)",
            choose_flooring: " Type de revêtement de sol (4/6)",
            specialfeatures: " Complément d'information (5/6)",
            filler_thikness: " Domaine / épaisseur (6/6)",
            calculate: " Afficher le résultat",
            special_combination: " Vos choix de support et de revêtement semblent être un cas particulier. Notre Service Technique pourra vous aider. Vous pouvez joindre le: <a href='tel:0033141632720'+33 (0)1 41 63 27 20</a>",
            resultbase: " Votre recommandation est basée sur la sélection suivante ",
            pdf_download: " Télécharger le PDF ",
            Standard: " Standard ",
            Schnellbau: " Installation rapide ",
            StarkeBelastung: " Charges lourdes ",
            InfoSubmitText: "For a layer thickness of 10 mm or more, please obtain technical application advice: UZIN technical team <a href='tel:00497314097257'>+49 731 4097-257</a> or <a href='info@uzin.com'>info@uzin.com</a>"
        },
    },
	en_nz: {
        translation: {
            Bodennavigator: "Floor Navigator",
            choose_type_subfloor: "Choose your subfloor. (1/6)",
            choose_subfloor: "Type of subfloor (2/6)",
            choose_type_flooring: "Which covering should be used? (3/6)",
            choose_flooring: "Type of covering (4/6)",
            specialfeatures: "Further information (5/6)",
            filler_thikness: "Area/Thickness (6/6)",
            calculate: "Display results",
            special_combination: "Your selected combination of subfloor and floor covering appears to be a special case. Our technicians will be happy to help you! Please contact our technical hotline: <a href='tel: +64 225 933782'>0064225933782</a>",
            resultbase: "Your recommendation is based on the following selection",
            pdf_download: "Download PDF",
            Standard: "Standard",
            Schnellbau: " Fast installation ",
            StarkeBelastung: "Heavy duty",
            InfoSubmitText: "For a layer thickness of 10 mm or more, please obtain technical application advice: UZIN technical team <a href='tel:00497314097257'>+49 731 4097-257</a> or <a href='info@uzin.com'>info@uzin.com</a>"
        },
    },
	nl: {
        translation: {
            Bodennavigator: " Vloer configurator ",
            choose_type_subfloor: " Maak een keuze (1/6)",
            choose_subfloor: " Type ondergrond (2/6)",
            choose_type_flooring: " Welk type bedekking ga je gebruiken? (3/6)",
            choose_flooring: " Type bedekking (4/6)",
            specialfeatures: " Systeem (5/6)",
            filler_thikness: " Oppervlakte/laagdikte (6/6)",
            calculate: " Resultaat weergeven ",
            special_combination: "De gekozen combinatie van bedekking en ondergrond is een bijzondere situatie. Onze technisch commercieel adviseurs staan klaar om je te helpen. Bel voor technische advies. <a href='tel:0031535737377'>+31 (0)53 573 73 77</a>",
            resultbase: " Je aanbeveling is gebaseerd op de volgende selectie ",
            pdf_download: " Downloaden PDF ",
            Standard: " Standaard ",
            Schnellbau: " Snelle installatie ",
            StarkeBelastung: " Zware belasting ",
            InfoSubmitText: "Voor een laagdikte van 10 mm of meer, vraag om technisch toepassingsadvies: UZIN technisch team <a href='www.uzin.com'>Contact uzin.com</a>"
        },
    },

};

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: "de_DE",
        interpolation: {
            escapeValue: false,
        },
        debug: true,
    });

export default i18next;
